import React from 'react'
import G from '../util/globalFunction'

//금액 -> 글자
const getAmountKo = (amount) =>{
    let args = []
    let argument = amount.toString();
    args.push(argument)
    let arrDigit1 = Array('', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구')
    let arrDigit3 = Array('', '십', '백', '천')
    let arrDigit4 = Array('', '만', '억', '조', '경', '해', '자', '양', '구', '간', '정', '재', '극')
    let digitIdx = 0;  //자릿수
    let digit4Idx = 0;  //arrDigit4의 index
    let digit4Rest = 0;  //4로 나눈 나머지
    let digit4Used = false;  //arrDigit4 사용여부
    let rslt = '';  //결과
    let amt = args[0];
    amt = amt.toString().replace(/[^\d\.]/g, '').replace(/\.\d+$/g, '')
    for(let idx = amt.length - 1; idx >= 0; idx--) {
        digit4Rest = digitIdx%4;
        if(digitIdx && !digit4Rest) {
            digit4Idx++;
            digit4Used = false;
        }
        if(amt[idx] > 0) {
            if(!digit4Used) {
                rslt = arrDigit4[digit4Idx] + rslt
                digit4Used = true;
            }
            rslt = arrDigit3[digit4Rest] + rslt
            rslt = arrDigit1[amt[idx]] + rslt
        }
       digitIdx++;
   }
   return (!rslt ? '영' : rslt) + G.t('trem.lang.home.0781'); //~원
}

 /********************
 * ViewMode Set
 * ******************/
const setViewMode = (className) => {
    let targetDocumentList = document.getElementsByClassName(className)
    if(targetDocumentList.length > 0) {
        let targetDocument = targetDocumentList[0]
        let inputElementList = targetDocument.querySelectorAll('input, textarea, select')
        if(inputElementList.length > 0) {
            for(let i = 0; i < inputElementList.length; i++) {
                let inputElement = inputElementList[i]
                if(inputElement.tagName == "INPUT") {
                    if(inputElement.type == "text") {
                        inputElement.setAttribute("readonly", true)
                        inputElement.style.backgroundColor = "transparent"
                        inputElement.style.boxShadow = "none"
                        inputElement.style.borderColor = "transparent"
                    } 
                    else if(inputElement.type == "number") {
                        inputElement.setAttribute("readonly", true)
                        inputElement.style.backgroundColor = "transparent"
                        inputElement.style.boxShadow = "none"
                        inputElement.style.borderColor = "transparent"
                    } 
                    else if(inputElement.type == "password") {
                        inputElement.style.display = 'none'
                    } 
                    else if(inputElement.type == "radio") {
                        inputElement.setAttribute("disabled", true)
                    } 
                    else if(inputElement.type == "checkbox") {
                        inputElement.setAttribute("disabled", true)
                    }
                    else if(inputElement.type == "button") {
                        inputElement.style.display = 'none'
                    }
                } 
                else if(inputElement.tagName == "TEXTAREA") {
                    inputElement.setAttribute("readonly", true)
                    inputElement.style.backgroundColor = "transparent"
                    inputElement.style.boxShadow = "none"
                    inputElement.style.borderColor = "transparent"
                    inputElement.style.resize = "none"
                }
                else if(inputElement.tagName == "SELECT") {
                    let selectedValue = inputElement.options[inputElement.selectedIndex].value
                    let selectedText = inputElement.options[inputElement.selectedIndex].text

                    let inputForSelectView = document.createElement('input');
                    inputForSelectView.type = 'text'
                    inputForSelectView.dataset.selectedValue = selectedValue
                    inputForSelectView.value = selectedText
                    inputForSelectView.setAttribute("readonly", true)
                    inputForSelectView.style.backgroundColor = "transparent"
                    inputForSelectView.style.boxShadow = "none"
                    inputForSelectView.style.borderColor = "transparent"
                    inputElement.after(inputForSelectView)
                    
                    // inputElement.style.display = 'none'
                    inputElement.remove()
                }
            }
        }
    }
}

// 긴 문자열 변경 (default length : 10, AppendStr : '...')
const fn_substrAppendStr = (str, length, AppendStr) => {
	var rtStr = "";
	
	if(!AppendStr) AppendStr = '...';
	
	if(!length) length = 10;
	
	if(str){
		var strLength = str.length;
		
		if(strLength > length){
			rtStr = str.substring(0, length) + AppendStr;
		}else{
			rtStr = str;
		}
	}
	
	return rtStr;
}

export { getAmountKo, setViewMode, fn_substrAppendStr}